import { CSSProperties, ReactNode } from 'react'
import clsx from 'clsx'
import StudentMenu from '../organisms/Menu/StudentMenu'
import {
  DASHBOARD_RESKIN_CHROME_MAX_CLASS,
  DASHBOARD_RESKIN_HEADER_BREAKOUT_CLASS,
  DASHBOARD_RESKIN_MENU_INSET_CLASS,
  DASHBOARD_RESKIN_MENU_STAGE_CLASS
} from './dashboardReskinTiles'

export const idReskinStudentHeader = 'reskin-student-header'
export const idReskinStudentHeaderColumn = 'reskin-student-header-column'
export const idReskinStudentMenuColumn = 'reskin-student-menu-column'

interface ReskinStudentHeaderProps {
  children?: ReactNode
  menuClassName?: string
  columnId?: string
  columnTestId?: string
  menuColumnId?: string
  menuColumnTestId?: string
  columnStyle?: CSSProperties
  menuColumnClassName?: string
  showMenu?: boolean
}

const ReskinStudentHeader: React.FC<ReskinStudentHeaderProps> = ({
  children,
  menuClassName,
  columnId = idReskinStudentHeaderColumn,
  columnTestId = idReskinStudentHeaderColumn,
  menuColumnId = idReskinStudentMenuColumn,
  menuColumnTestId = idReskinStudentMenuColumn,
  columnStyle,
  menuColumnClassName,
  showMenu = true
}) => (
  <div
    className={`${DASHBOARD_RESKIN_HEADER_BREAKOUT_CLASS} ${DASHBOARD_RESKIN_MENU_STAGE_CLASS}`}
    data-testid={idReskinStudentHeader}
  >
    <div
      id={columnId}
      data-testid={columnTestId}
      className={DASHBOARD_RESKIN_CHROME_MAX_CLASS}
      style={columnStyle}
    >
      {showMenu && (
        <div
          id={menuColumnId}
          data-testid={menuColumnTestId}
          className={clsx(DASHBOARD_RESKIN_MENU_INSET_CLASS, menuColumnClassName)}
        >
          <StudentMenu align='start' className={menuClassName} />
        </div>
      )}
      {children}
    </div>
  </div>
)

export default ReskinStudentHeader
